module.exports = __webpack_public_path__ + "static/img/game-balance.90a6b331.svg";